import TRCForm from "./components/trcAccessForm/trcForm";
import TRCFormTitle from "./components/trcHeading/trcTitle";


const TRCRequestPage = () => {
	return (
		<>
			<TRCFormTitle tagline="Access exclusive content and resources to enhance your teaching skills.">
				Request Access to Teacher Resource Center
			</TRCFormTitle>
			<TRCForm />
		</>
	);
};

export default TRCRequestPage;
